// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"441":"602f8b25","899":"7c9b7293"}[chunkId] + ".chunk.css";
};